export const GhostCard = () => (
  <div className="mx-auto flex w-full flex-col gap-5">
    <div
      className="
        flex animate-pulse flex-col gap-2 rounded-lg
        bg-background-surface-container
      "
    >
      <div
        className="
          mb-1 h-8 w-1/2 rounded-sm bg-background-surface-container-variant-low
        "
      />
      <div className="h-4 rounded-sm bg-background-surface-container-variant-low" />
    </div>
    <div
      className="
        flex animate-pulse flex-col gap-2 rounded-lg
        bg-background-surface-container
      "
    >
      <div
        className="
          mb-1 h-8 w-1/2 rounded-sm bg-background-surface-container-variant-low
        "
      />
      <div className="h-4 rounded-sm bg-background-surface-container-variant-low" />
    </div>
    <div
      className="
        flex animate-pulse flex-col gap-2 rounded-lg
        bg-background-surface-container
      "
    >
      <div
        className="
          mb-1 h-8 w-1/2 rounded-sm bg-background-surface-container-variant-low
        "
      />
      <div className="h-4 rounded-sm bg-background-surface-container-variant-low" />
    </div>
    <div
      className="
        flex animate-pulse flex-col gap-2 rounded-lg
        bg-background-surface-container
      "
    >
      <div
        className="
          mb-1 h-8 w-1/2 rounded-sm bg-background-surface-container-variant-low
        "
      />
      <div className="h-4 rounded-sm bg-background-surface-container-variant-low" />
    </div>
    <div
      className="
        flex animate-pulse flex-col gap-2 rounded-lg
        bg-background-surface-container
      "
    >
      <div
        className="
          mb-1 h-8 w-1/2 rounded-sm bg-background-surface-container-variant-low
        "
      />
      <div className="h-4 rounded-sm bg-background-surface-container-variant-low" />
    </div>
  </div>
);
